import { fromFetch } from 'rxjs/fetch';

import { AuthHeaders } from '../../../models/auth-headers';
import { dataAccessEnvironment } from '../../../models/data-access-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { UserPagedCollectionParams } from '../../../models/user-paged-collection-params';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { accountsEnvironment } from '../accounts-environment';
import { jobTraceIdResponseSchema } from '../schemas/job-trace-id-response.schema';

/**
 * Sends a notification message to filtered assets based on fleet info criteria.
 * @param params User Paged Collection Params
 * @param message The message (<= 280 characters) to send to each asset
 * @returns The job trace ID
 */
export function postBulkNotifyAsset(
  this: unknown,
  params: UserPagedCollectionParams,
  message: string,
  assetIds: string[]
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${accountsEnvironment.resolve(this).bulkNotifyAssetUrl()}?${params.urlParams}`,
        {
          method: 'POST',
          headers: {
            ...requiredHeaders,
            ...(dataAccessEnvironment.configuration.useLegacyTokenForAccountsApi
              ? new AuthHeaders()
              : jwtAuthHeaders),
          },
          body: JSON.stringify({
            message,
            assetIds: assetIds.length > 0 ? assetIds : undefined,
          }),
        }
      )
    )
  ).pipe(selectData(jobTraceIdResponseSchema));
}
